import { TimelineStore } from "../../store/TimelineStore";
import {SequenceTimelineStore} from "../../../sequenceEditor/store/SequenceTimelineStore";
import {SequenceStateStore} from "../../../sequenceEditor/store/SequenceStateStore";
import { TIMELINE_RULER_TICK_WIDTH_PX } from "../../config/config";

export function convertUnitsToTime(time: number, isSequence: boolean = false): number {
  if (!Number.isFinite(time)) return 0;

  // Timeline virtualization path (non-sequence): the input is x in TRACK CONTENT coordinates
  // (i.e. after left pad), and the output is absolute time in seconds.
  if (!isSequence) {
    const pxPerSec = TIMELINE_RULER_TICK_WIDTH_PX * TimelineStore.zoom;
    if (!Number.isFinite(pxPerSec) || pxPerSec <= 0) return TimelineStore.baseStartSec ?? 0;
    const baseStartSec = TimelineStore.baseStartSec ?? 0;
    return baseStartSec + (time / pxPerSec);
  }

  const timelineWidth = SequenceTimelineStore.width;
  const timelineZoom = SequenceTimelineStore.zoom;
  const duration = SequenceStateStore.duration;

  const ratio = (timelineWidth / duration) * timelineZoom;
  return time / ratio;
}
